// https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/readyState 참고
export enum MediaElementReadyStateType {
  HAVE_NOTHING = 0,
  HAVE_METADATA = 1,
  HAVE_CURRENT_DATA = 2,
  HAVE_FUTURE_DATA = 3,
  HAVE_ENOUGH_DATA = 4,
}
